import { join } from 'light-component';
import { Box, useTranslation } from '@common';
import { DragItem, Highlighter } from '../../component';
import styles from '../style.module.less';
import { RichTextComponent } from './richText';
import type { ReactElement } from 'react';
import type { RichTextProps } from './types';

export function RichTextViewMode(props: RichTextProps): ReactElement {
  const [t] = useTranslation();

  if (props.name == null) {
    return (
      <DragItem title={t('RichText')} />
    );
  }

  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <RichTextComponent {...props} />
      </Box>
    </Box>
  );
}
